// HIMS Role-Based Access Control

export const ROLES = {
    SUPER_ADMIN:    'super_admin',
    IT_MANAGER:     'it_manager',
    HOSPITAL_ADMIN: 'hospital_admin',
    DOCTOR:         'doctor',
    DOCTOR_OPD:     'doctor_opd',
    DOCTOR_AE:      'doctor_ae',
    NURSE:          'nurse',
    LAB_TECH:       'lab_tech',
    RADIOLOGIST:    'radiologist',
    RECEPTION:      'reception',
    PHARMACIST:     'pharmacist',
    VIEWER:         'viewer',
};

export const MODULE_ACCESS = {
    dashboard:  ['super_admin','it_manager','hospital_admin','doctor','doctor_opd','doctor_ae','nurse','lab_tech','radiologist','reception','pharmacist','viewer'],
    opd:        ['super_admin','it_manager','hospital_admin','doctor','doctor_opd','doctor_ae','reception','viewer'],
    ipd:        ['super_admin','it_manager','hospital_admin','doctor','doctor_opd','doctor_ae','nurse','viewer'],
    emergency:  ['super_admin','it_manager','hospital_admin','doctor','doctor_opd','doctor_ae','nurse','reception','viewer'],
    lab:        ['super_admin','it_manager','hospital_admin','doctor','doctor_opd','doctor_ae','lab_tech','lab_technician','viewer'],
    radiology:  ['super_admin','it_manager','hospital_admin','doctor','doctor_opd','doctor_ae','radiologist','viewer'],
    psychiatry: ['super_admin','it_manager','hospital_admin','doctor','doctor_opd','doctor_ae','viewer'],
    pharmacy:   ['super_admin','it_manager','hospital_admin','pharmacist','doctor','doctor_opd','doctor_ae','viewer'],
    blood_bank: ['super_admin','it_manager','hospital_admin','doctor','doctor_opd','doctor_ae','nurse','viewer'],
    patients:   ['super_admin','it_manager','hospital_admin','doctor','doctor_opd','doctor_ae','nurse','reception','viewer'],
    reports:    ['super_admin','it_manager','hospital_admin','doctor','doctor_opd','doctor_ae','nurse','viewer'],
    user_mgmt:  ['super_admin','it_manager'],
    queue:      ['super_admin','it_manager','hospital_admin','doctor','doctor_opd','doctor_ae','nurse','reception','lab_tech','radiologist','viewer'],
    physio:     ['super_admin','it_manager','hospital_admin','doctor','doctor_opd','doctor_ae','nurse','viewer'],
    icu:        ['super_admin','it_manager','hospital_admin','doctor','doctor_opd','doctor_ae','nurse','viewer'],
};

export function canAccess(userRole, module) {
    if (!userRole || !module) return false;
    const allowed = MODULE_ACCESS[module];
    if (!allowed) return false;
    return allowed.includes(userRole);
}

export function isReadOnly(userRole) {
    return userRole === 'viewer';
}

export const ROLE_LABELS = {
    super_admin:    'Super Admin',
    it_manager:     'IT Manager',
    hospital_admin: 'Hospital Admin',
    doctor:         'Doctor',
    doctor_opd:     'Doctor (OPD)',
    doctor_ae:      'Doctor (A&E)',
    nurse:          'Nurse',
    lab_tech:       'Lab Technician',
    radiologist:    'Radiologist',
    reception:      'Receptionist',
    pharmacist:     'Pharmacist',
    viewer:         'Viewer (Read Only)',
};

export const ROLE_COLORS = {
    super_admin:    { bg: '#1e3a5f', text: '#fff' },
    it_manager:     { bg: '#1e3a5f', text: '#fff' },
    hospital_admin: { bg: '#065f46', text: '#fff' },
    doctor:         { bg: '#0369a1', text: '#fff' },
    doctor_opd:     { bg: '#0369a1', text: '#fff' },
    doctor_ae:      { bg: '#b45309', text: '#fff' },
    nurse:          { bg: '#0f766e', text: '#fff' },
    lab_tech:       { bg: '#7c3aed', text: '#fff' },
    lab_technician: { bg: '#7c3aed', text: '#fff' },
    radiologist:    { bg: '#0369a1', text: '#fff' },
    reception:      { bg: '#92400e', text: '#fff' },
    pharmacist:     { bg: '#065f46', text: '#fff' },
    viewer:         { bg: '#64748b', text: '#fff' },
};